import { useState } from "react";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { Icon } from "../../icon/Icon";
import style from "./navbar.module.scss";
import { FaBars, FaBell } from "react-icons/fa";
import { ListItems } from "../../molecules/listItem/ListItem";
import { navigationData } from "../../../utils/helper";
import { GrClose } from "react-icons/gr";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";
import { useLocation, useNavigate } from "react-router-dom";
import { useNotifications } from "../../../hooks/useNotifications";
import { NotificationDropdown } from "../../molecules/notificationDropdown/NotificationDropdown";
import { LiveCallsDropdown } from "../../molecules/liveCallsDropdown/LiveCallsDropdown";

export const Navbar = () => {
  const navigate=useNavigate();
  const params = useLocation();
  const isLoginPath = params.pathname === "/login";
  // const isTicket = params.pathname === "/";
  const { getUserData } = UseGetStoreData();
  const [showMenu, setShowMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications, unreadCount, handleNotificationClick } = useNotifications();
  
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <>
      <Container className={style.wrapper}>
        <div className={style.nav_left}>
          <div onClick={()=>navigate("/")} className={style.logo}>
            <Icon src="/images/pocoLogo.png" alt="PocoLogo" />
          </div>
        </div>
       {!isLoginPath&& <div className={style.nav_right}>
          <LiveCallsDropdown />
          <div className={style.notification_btn} onClick={() => setShowNotifications(true)}>
            <FaBell size={20} />
            {unreadCount > 0 && <span className={style.notification_badge}>{unreadCount}</span>}
          </div>
          <div className={style.user_profile}>
            <Icon src="/images/user_icon.png" alt="PocoLogo" />
          </div>
          {getUserData && (
            <div>
              <Text text={getUserData?.name} className={style.agent_name} />
              <Text text="Pococare Heartbeat" className={style.role} />
            </div>
          )}
          <div className={style.hamburger_icon} onClick={toggleMenu}>
            {showMenu ? <GrClose /> : <FaBars />}
          </div>
        </div>}
      </Container>
      {showMenu && (
        <div className={style.menu}>
          <ListItems closeModal={toggleMenu} className={style.list} data={navigationData} />
        </div>
      )}
      <NotificationDropdown
        isVisible={showNotifications}
        notifications={notifications}
        onClose={() => setShowNotifications(false)}
        onNotificationClick={handleNotificationClick}
      />
    </>
  );
};
